import { useState } from 'react';
import type { PendingItemWithProvider } from '../../../../../types';

export type UsePendingItemMenuActionsProps = {
  item: PendingItemWithProvider;
  onEdit: () => void;
  onDelete: () => void | Promise<unknown>;
};

export function usePendingItemMenuActions(props: UsePendingItemMenuActionsProps) {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);

  function handleEditClick() {
    props.onEdit();
  }

  function handleDeleteClick() {
    setIsDeleteModalOpen(true);
  }

  function handleDeleteModalClose() {
    setIsDeleteModalOpen(false);
  }

  async function handleConfirmDelete() {
    await props.onDelete();
    setIsDeleteModalOpen(false);
  }

  return {
    isDeleteModalOpen,
    handleEditClick,
    handleDeleteClick,
    handleDeleteModalClose,
    handleConfirmDelete,
  };
}
